export const createGlobalTimeout = (name: string) => {
  const map = new Map()

  const clear = () => {
    const timeoutId = map.get(name)

    if (timeoutId) {
      clearTimeout(timeoutId)
      map.delete(name)
    }
  }

  return {
    get timeout() {
      return map.get(name)
    },

    set(callback: () => void, ms: number) {
      clear()

      const timeoutId = setTimeout(() => {
        callback()
        clear()
      }, ms)

      map.set(name, timeoutId)

      return timeoutId
    },

    clear,
  }
}
